export const queryKeys = {
  GetOrders: 'GetOrders',
} as const;
